import { forwardRef, type HTMLAttributes } from 'react';

import { cx } from './shared';

export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  tone?: 'default' | 'raised' | 'recessed';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  density?: 'comfortable' | 'compact';
}

const toneClass = {
  default: 'border-border-subtle bg-surface shadow-none',
  raised: 'border-border-subtle bg-surface-raised shadow-raised',
  recessed: 'border-border-subtle bg-surface-recessed shadow-inset',
};

const paddingClass = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
  (
    {
      tone = 'default',
      padding = 'md',
      density = 'comfortable',
      className,
      ...rest
    },
    ref,
  ) => (
    <div
      ref={ref}
      data-density={density}
      className={cx(
        'rounded-surface border text-ink',
        toneClass[tone],
        paddingClass[padding],
        className,
      )}
      {...rest}
    />
  ),
);

Surface.displayName = 'Surface';
